export default __webpack_public_path__ + "static/media/cost-explorer.3991d993.png";